<!--
 * @Descripttion: 易起问点击立即调起下载组件
 * @version: 1.0.0
 * @Author: HeYang
 * @Date: 2019-11-01 14:17:52
 * @LastEditors: HeYang
 * @LastEditTime: 2020-11-24 19:34:24
 * @使用
    <commonLjdsDownLoad
        ref="download"
        tag="麦玲玲福利版下载页"
        :downLoadTime="2000"
    ></commonLjdsDownLoad>
    设置ref，通过(this.$refs.download as any).downloadAPP()在父页面按钮直接调起下载
 * @params:
    1. tag: 按(iOS，安卓)、channel添加下载按钮事件统计，不传则不添加下载按钮事件百度统计；
    2. downLoadTime: 静默下载时间，不传则不静默下载。
 -->
<template>
	<div class="download-container">
		<van-popup @click="hidePop" v-model="showPop" position="top" class="download-pop" get-container="body">
			<div class="tip-box">
				<img v-if="showAndroidPop" class="android-box" src="../../image/ic_Android_ browser.png" alt="" />
				<template  v-if="showIosPop">
					<div class="safari-box">
						<img src="../../image/ic_Safari.png" alt="" />
						<p>请选择</p>
						<p>在Safari中打开</p>
					</div>
					<img class="icon-line" src="../../image/ic_line.png" alt="" />
				</template>
			</div>
		</van-popup>
		<!-- 安卓在浏览器打开弹窗 -->
		<!-- <div class="dialog-guide-to-browser" v-if="showAndroidPop" @click="() => this.showAndroidPop = !this.showAndroidPop">
			<div class="mask" :style="{height: pageHeight + 'px'}"></div>
			<img class="android-box" src="../../image/ic_Android_ browser.png" alt="" />
		</div> -->
		<!-- iOS在Safari打开弹窗 -->
		<!-- <div class="dialog-guide-to-safari" v-if="showIosPop" @click="() => this.showIosPop = !this.showIosPop">
			<div class="mask" :style="{height: pageHeight + 'px'}"></div>
			<div class="safari-box">
				<img src="../../image/ic_Safari.png" alt="" />
				<p>请选择</p>
				<p>在Safari中打开</p>
			</div>
			<img class="icon-line" src="../../image/ic_line.png" alt="" />
		</div> -->
	</div>
</template>
<script>
import {commonFn} from '../../common/js/common.js';
import myAjax from '../../common/js/request.js';
import {apiPath} from '../../common/js/config.js';

const marketLinkList = {
	huawei: 'appmarket://details?id=com.hl.tingzhi',
	honor: 'honormarket://details?id=com.hl.tingzhi',
	harmony: 'store://appgallery.huawei.com/app/detail?id=mmc.tingzhi.hm',
	xiaomi: 'mimarket://details?id=com.mmc.linghit',
	oppo: 'oppomarket://details?packagename=com.mmc.linghit',
	vivo: 'vivomarket://details?id=com.mmc.linghit'
};

export default {
	props: ['downLoadTime', 'tag'],
	data() {
		return {
			showAndroidPop: false,
			showIosPop: false,
			// APP下载链接
			downloadUrl: '',
			channel: commonFn.getParams()['channel'] || localStorage.getItem('channel') || '',
			showPop: false
		};
	},
	methods: {
		getPhoneMarketLink() {
			if (/baiduboxapp|baidubrowser/i.test(navigator.userAgent)) return;
			return new Promise((resolve, reject) => {
				Object.values(marketLinkList).forEach(marketLink => {
					try {
						location.href = marketLink;
						reject(new Error('成功跳转到应用市场'));
					} catch (error) {
						console.log(error);
					}
				});
				resolve();
			});
		},
		hidePop() {
			this.showAndroidPop = false;
			this.showIosPop = false;
			this.showPop = false;
		},
		layer(text, time) {
			this.$store.commit('showLayer', text);
		},
		// 联登处理，复制TZ#TOKEN=xxxxxxxxxxxxx到剪切板
		reLogin() {
			let token = commonFn.getParams()['token'] || localStorage.getItem('yiQiWenToken') || '';
			if (token) {
				let copyTxt = `TZ#TOKEN=${token}`;
				console.log(copyTxt, 'copyTxt');
				this.$copyText(copyTxt)
				.then(() => {
						console.log('复制成功');
				})
				.catch((err) => {
						console.error('复制出错', err);
				});
			}
		},
		// APP下载
		async downloadAPP(nendTag = false, dlTag = "", isOnlyCopy = false, preferMarket = false) {
			this.reLogin();

			if (this.showPop) {
				return;
			}
			let {channel, tag, downloadUrl} = this;

            // if (dlTag && nendTag) {
            //     commonFn.addTrackEvent(dlTag, '全屏下载页点击下载', channel);
            //     commonFn.addTrackEvent(dlTag, '全屏下载页点击下载', '渠道汇总');
			// }

			if (preferMarket && !downloadUrl) {
				try {
					await this.getdownloadUrl();
				} catch (error) {
					this.layer('获取下载链接失败');
					return;
				}
				downloadUrl = this.downloadUrl;
			}
			if (!downloadUrl) {
				this.layer('获取下载链接失败');
				return;
			}
			if (commonFn.parseUA().ios) {
				if (tag) {
					commonFn.addTrackEvent(tag, '点击下载按钮', channel);
				}
				if (commonFn.parseUA().weibo) {
					this.showPop = true;
					this.showIosPop = true;
					return;
				}
			} else {
				if (tag) {
					commonFn.addTrackEvent(tag, '点击下载按钮', channel);
				}
				if (commonFn.parseUA().weixin || commonFn.parseUA().weibo) {
					this.showPop = true;
					this.showAndroidPop = true;
					return;
				}
			}

			if(isOnlyCopy) {
				this.$copyText(downloadUrl).then(() => {
					this.layer('复制成功，请在浏览器中打开');
				}).catch(err => {
						console.error('复制出错', err);
				})
				return;
			}

			if (preferMarket && !commonFn.parseUA().ios) {
				try {
					await this.getPhoneMarketLink();
				} catch (error) {
					return;
				}
			}
			location.href = downloadUrl;
			// setTimeout(() => {
			// 	this.layer('无法下载APP？请点击下方复制链接在浏览器中粘贴链接并打开');
			// }, 2000);
			return;
			this.$copyText(downloadUrl).then(() => {
				if (isOnlyCopy) {
					this.layer('复制成功，请在浏览器中打开');
					return;
				}

				location.href = downloadUrl;

                setTimeout(() => {
									this.layer('无法下载APP？请在浏览器中粘贴链接并打开');
                }, 2000);
            }).catch(err => {
				location.href = downloadUrl;
                console.error('复制出错', err);
			})
		},
        parseLink(value) {
            const token =
                commonFn.getParams()['token'] ||
                localStorage.getItem('yiQiWenToken') ||
                commonFn.getCookieItem('_token') ||
                '';
            try {
                const url = new URL(value);
                if (url.pathname.startsWith('/dist/') && token) {
                    const search = new URLSearchParams(url.search);
                    search.delete('token');
                    search.append('token', token);
                    let searchStr = search.toString();
                    searchStr = searchStr.startsWith('?') ? searchStr : '?' + searchStr;
                    return `${url.origin}${url.pathname}${searchStr}`;
                }
            } catch (e) {
                console.error(e);
            }
            return value;
        },
		async getdownloadUrl() {
			let { tf_channel_app_match = this.channel } = await commonFn.getConfig();
			const {huawei: isHuawei, oppo: isOppo} = commonFn.parseUA();

			let data = {
				channel: isHuawei ? 'android_huawei' : tf_channel_app_match,
				sys: commonFn.parseUA().ios ? 1 : 0
			};
			let urlRes = await myAjax.get(apiPath.getLjdsDownUrl, data);
			if (urlRes && urlRes.link) {
				this.downloadUrl = this.parseLink(urlRes.link);
                this.$emit('getDownloadLink', urlRes.link);
			}
			if (this.downLoadTime > -1) {
				setTimeout(() => {
					this.downloadAPP();
				}, this.downLoadTime);
			}
		}
	},
	mounted() {
		this.getdownloadUrl();
	}
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.dialog-guide-to-browser {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 999;
	.mask {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 5;
	}
	.android-box {
		display: block;
		width: 6.520rem;
		height: auto;
		position: absolute;
		z-index: 10;
		right: 0.880rem;
		top: 0.133rem;
	}
}
.dialog-guide-to-safari {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	z-index: 1000;
	.mask {
		position: fixed;
		left: 0;
		top: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.7);
		z-index: 5;
	}
	.safari-box {
		position: absolute;
		z-index: 10;
		top: 3.733rem;
		left: 50%;
		width: 4rem;
		margin-left: -2rem;
		> img {
			display: block;
			width: 1.600rem;
			height: 1.600rem;
			margin: 0 auto 0.267rem;
		}
		p {
			color: #ffffff;
			font-size: 0.373rem;
			text-align: center;
		}
	}
	.icon-line {
		display: block;
		width: 3.467rem;
		height: auto;
		position: absolute;
		z-index: 10;
		right: 0.533rem;
		top: 0.267rem;
	}
}
.download-pop {
	background: transparent;
}
.tip-box {
	position: relative;
	width: 10rem;
	height: 7.333rem;
}
.android-box {
	display: block;
	width: 6.520rem;
	height: auto;
	position: absolute;
	z-index: 10;
	right: 0.880rem;
	top: 0.133rem;
}
.safari-box {
	position: absolute;
	z-index: 10;
	top: 3.733rem;
	left: 50%;
	width: 4rem;
	margin-left: -2rem;
	> img {
		display: block;
		width: 1.600rem;
		height: 1.600rem;
		margin: 0 auto 0.267rem;
	}
	p {
		color: #ffffff;
		font-size: 0.373rem;
		text-align: center;
	}
}
.icon-line {
	display: block;
	width: 3.467rem;
	height: auto;
	position: absolute;
	z-index: 10;
	right: 0.533rem;
	top: 0.267rem;
}
</style>
<style lang="less">
.download-pop.van-popup.van-popup--top {
	position: fixed;
	left: 0;
	top: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.7)!important;
	z-index: 9999999!important;
}
</style>



// WEBPACK FOOTER //
// commonLjdsDownload.vue?2b6ca72a